import { render } from "./TasksKanban.vue?vue&type=template&id=45598855"
import script from "./TasksKanban.vue?vue&type=script&lang=js"
export * from "./TasksKanban.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__